// NOTE: 'animals' is for storing an offline list of animals to show when offline but 'syncAnimals'
// is for storing offline submitted pending animals to sync with back end when get online

import connector from '../connector';

// eslint-disable-next-line no-async-promise-executor
const addAnimalsList = (animalsList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('animals', 'readwrite');
        const animalsStore = transaction.objectStore('animals');

        animalsStore.clear(); // delete all of the previously added animals to add the new list

        animalsList.forEach(singleAnimal => {
            animalsStore.add(singleAnimal);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

// eslint-disable-next-line no-async-promise-executor
const getAnimal = (id) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('animals', 'readonly');
        const animalsStore = transaction.objectStore('animals');

        const animal = animalsStore.get(parseInt(id));

        transaction.oncomplete = () => {
            db.close();
            if (animal.result) {
                resolve({ success: true, animal: animal.result });
            }
            else {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

// eslint-disable-next-line no-async-promise-executor
const getAnimalsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('animals', 'readonly');
        const animalsStore = transaction.objectStore('animals');

        const allAnimals = animalsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allAnimals.result });
        };
    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

// eslint-disable-next-line no-async-promise-executor, @typescript-eslint/no-unused-vars
const getFilteredAnimalsList = (start = 0, end = 300, filters = null) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('animals', 'readonly');
        const animalsStore = transaction.objectStore('animals');

        const allAnimals = animalsStore.getAll();

        transaction.oncomplete = () => {

            const reversedList = [...allAnimals.result];
            reversedList.reverse();
            const paginationScopeList = [...reversedList.splice(start, end + 1)];

            db.close();
            resolve({ success: true, data: paginationScopeList });
        };

    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

// eslint-disable-next-line no-async-promise-executor
const findAnimals = (searchTerm) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('animals', 'readonly');
        const animalsStore = transaction.objectStore('animals');

        const allAnimals = animalsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            const animalsList = allAnimals.result;
            const filteredAnimals = animalsList.filter(animal => {
                if (
                    (animal?.earTagNo?.toLowerCase().indexOf(searchTerm.toString().toLowerCase()) > -1) ||
                    (animal?.name?.toLowerCase().indexOf(searchTerm.toString().toLowerCase()) > -1) ||
                    (animal?.groupName?.toLowerCase().indexOf(searchTerm.toString().toLowerCase()) > -1)
                ) {
                    return true;
                }
                else {
                    return false;
                }
            });
            resolve({ success: true, data: filteredAnimals });
        };
    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

const animals = {
    addAnimalsList,
    getAnimal,
    getAnimalsList,
    getFilteredAnimalsList,
    findAnimals
}

export default animals;
